module.exports = __webpack_public_path__ + "media/images/client/video_poster-5e04dfa9a216c07c5daa200671a853f1.png";